module.exports = __webpack_public_path__ + "img/awards_image_17.90b46b82.jpg";